/**
 * Workshop booking wizard — venue → (waitlist | calendar/time) → multi-variant cart.
 * Pricing: window.resolveWorkshopPrice (workshop-booking.js).
 */
(function () {
  'use strict';

  window.__wbwWizardScriptRev = '2026-08-17-seo-head-jsonld';
  window.__wbwPromoDiag = { scriptLoaded: true, phase: 'parsing' };

  if (window.__WB_INITIAL_VARIANT__ == null || String(window.__WB_INITIAL_VARIANT__).trim() === '') {
    try {
      var _wbVar = new URLSearchParams(window.location.search).get('variant');
      if (_wbVar && String(_wbVar).trim()) window.__WB_INITIAL_VARIANT__ = String(_wbVar).trim();
    } catch (_) {}
  }


  var H = window.WorkshopBookingWizardHelpers || {};
  var Flow = H.Flow;
  var LiveApi = H.LiveApi;
  var WizardLive = H.WizardLive;
  var WBWUtils = H.WBWUtils;
  var MONTHS = H.MONTHS;
  var DOW_PICKER = H.DOW_PICKER;
  var DOW_MED = H.DOW_MED;
  var DOW_SHORT = H.DOW_SHORT;
  var VARIANT_ROW_MIN_PX = H.VARIANT_ROW_MIN_PX;
  var VARIANT_ROW_MIN_H_PX = H.VARIANT_ROW_MIN_H_PX;
  var VARIANT_GRID_GAP_PX = H.VARIANT_GRID_GAP_PX;
  var getLiveApi = H.getLiveApi;
  var getWizardLive = H.getWizardLive;
  var parseData = H.parseData;
  var WB_WORKSHOP_TYPES = H.WB_WORKSHOP_TYPES;
  var workshopTypeFromText = H.workshopTypeFromText;
  var fetchWorkshopTypeFromProduct = H.fetchWorkshopTypeFromProduct;
  var resolveWaitlistWorkshopType = H.resolveWaitlistWorkshopType;
  var parseSiblingPromoData = H.parseSiblingPromoData;
  var siblingPromoScope = H.siblingPromoScope;
  var attachSiblingPromoHost = H.attachSiblingPromoHost;
  var ensureSiblingPromoDom = H.ensureSiblingPromoDom;
  var siblingPromoHosts = H.siblingPromoHosts;
  var WB_HANDLE_ALIAS_GROUPS = H.WB_HANDLE_ALIAS_GROUPS;
  var handlesMatchForPromo = H.handlesMatchForPromo;
  var canonicalPromoHandle = H.canonicalPromoHandle;
  var normalizeTimeLabel = H.normalizeTimeLabel;
  var parseTimeLabelParts = H.parseTimeLabelParts;
  var formatHourMinuteMeridiem = H.formatHourMinuteMeridiem;
  var timePartsToMinutes = H.timePartsToMinutes;
  var formatSessionTimeRange = H.formatSessionTimeRange;
  var buildPromoVenueContext = H.buildPromoVenueContext;
  var venueRowMatchesContextScore = H.venueRowMatchesContextScore;
  var resolvePromoDeepLinkFromIndex = H.resolvePromoDeepLinkFromIndex;
  var WB_SIBLING_HANDLE_FALLBACKS = H.WB_SIBLING_HANDLE_FALLBACKS;
  var WB_SIBLING_LABELS = H.WB_SIBLING_LABELS;
  var parseVenueWaitlistCatalog = H.parseVenueWaitlistCatalog;
  var findCatalogVenueByToken = H.findCatalogVenueByToken;
  var parseVenueWorkshopIndex = H.parseVenueWorkshopIndex;
  var findIndexRowByEventId = H.findIndexRowByEventId;
  var promoEventIdMatchesVenueContext = H.promoEventIdMatchesVenueContext;
  var resolveVenueAnchoredPromoEventId = H.resolveVenueAnchoredPromoEventId;
  var resolveEventIdForProductAtVenue = H.resolveEventIdForProductAtVenue;
  var slotListContainsEventId = H.slotListContainsEventId;
  var resolveSiblingEventIdFromSessionAnchor = H.resolveSiblingEventIdFromSessionAnchor;
  var venueRefAliasKeys = H.venueRefAliasKeys;
  var venueNameLookupKey = H.venueNameLookupKey;
  var buildVenueWorkshopMaps = H.buildVenueWorkshopMaps;
  var normalizeVenueRefId = H.normalizeVenueRefId;
  var ensureSiblingWorkshops = H.ensureSiblingWorkshops;
  var collectAlsoAvailableHandles = H.collectAlsoAvailableHandles;
  var escapeHtml = H.escapeHtml;
  var extractNumericEventIdForUrl = H.extractNumericEventIdForUrl;
  var extractNumericVariantIdForUrl = H.extractNumericVariantIdForUrl;
  var extractNumericVenueRefForUrl = H.extractNumericVenueRefForUrl;
  var extractEventIdFromUrl = H.extractEventIdFromUrl;
  var extractPromoEventIdFromProduct = H.extractPromoEventIdFromProduct;
  var refsOverlap = H.refsOverlap;
  var venueNamesLooselyMatch = H.venueNamesLooselyMatch;
  var venueMatchesIndexRow = H.venueMatchesIndexRow;
  var readInitialVariantIdFromUrl = H.readInitialVariantIdFromUrl;
  var getEventIdFromUrl = H.getEventIdFromUrl;
  var getVenueTokenFromUrl = H.getVenueTokenFromUrl;
  var getCityTokenFromUrl = H.getCityTokenFromUrl || getVenueTokenFromUrl;
  var getDateFromUrl = H.getDateFromUrl || function () { return ''; };
  var cityUrlToken = H.cityUrlToken || H.venueUrlToken;
  var urlHasWizardDeepLink = H.urlHasWizardDeepLink;
  var venueCardIsWaitlistOnly = H.venueCardIsWaitlistOnly;
  var getWbwStepFromUrl = H.getWbwStepFromUrl;
  var clearWbwStepFromUrl = H.clearWbwStepFromUrl;
  var isVenueHandleToken = H.isVenueHandleToken;
  var venueUrlToken = H.venueUrlToken;
  var venueHandleFromSlotRaw = H.venueHandleFromSlotRaw;
  var venueMatchesUrlToken = H.venueMatchesUrlToken;
  var updateWizardBookingUrl = H.updateWizardBookingUrl;
  var formatMoney = H.formatMoney;
  var slotBookable = H.slotBookable;
  var slotStatus = H.slotStatus;
  var slotDisplayStatus = H.slotDisplayStatus;
  var slotHidden = H.slotHidden;
  var slotSoldOut = H.slotSoldOut;
  var slotVisible = H.slotVisible;
  var formatSlotOptionText = H.formatSlotOptionText;
  var slotDateKey = H.slotDateKey;
  var padDatePart = H.padDatePart;
  var toIsoDateKey = H.toIsoDateKey;
  var timeLabelFromDateTime = H.timeLabelFromDateTime;
  var normalizeEventToSlot = H.normalizeEventToSlot;
  var eventsToSlots = H.eventsToSlots;
  var buildDaysMap = H.buildDaysMap;
  var wizardViewportWidth = H.wizardViewportWidth;
  var calendarDowLabels = H.calendarDowLabels;
  var calDateKey = H.calDateKey;
  var formatCalDateBtn = H.formatCalDateBtn;
  var formatBookingSubLabel = H.formatBookingSubLabel;
  var isStoreVenue = H.isStoreVenue;
  var formatPopupDateLabel = H.formatPopupDateLabel;
  var vQtyKey = H.vQtyKey;
  var normalizeOptionValue = H.normalizeOptionValue;
  var styleValueFromVariant = H.styleValueFromVariant;
  var getSectionRoot = H.getSectionRoot;
  var isSessionOptionHandle = H.isSessionOptionHandle;
  var parseVariantsJson = H.parseVariantsJson;
  var ensureVariantMediaMeta = H.ensureVariantMediaMeta;
  var findShopifyVariantByWizard = H.findShopifyVariantByWizard;
  var findStyleFieldset = H.findStyleFieldset;
  var getProductContainer = H.getProductContainer;
  var goToImpulseVariantMedia = H.goToImpulseVariantMedia;
  var parseZoomThumbMediaId = H.parseZoomThumbMediaId;
  var parseZoomSlideMediaId = H.parseZoomSlideMediaId;
  var goToZoomGalleryByMediaId = H.goToZoomGalleryByMediaId;
  var findImpulseMediaSlide = H.findImpulseMediaSlide;
  var resolveImpulseMediaZoomPosition = H.resolveImpulseMediaZoomPosition;
  var raiseImpulseProductModal = H.raiseImpulseProductModal;
  var openImpulseProductZoom = H.openImpulseProductZoom;
  var closeImpulseProductZoom = H.closeImpulseProductZoom;
  var openWizardVariantImageFallback = H.openWizardVariantImageFallback;
  var syncImpulseStyleOption = H.syncImpulseStyleOption;
  var syncImpulseOptionsByVariant = H.syncImpulseOptionsByVariant;
  var syncImpulseMasterVariantId = H.syncImpulseMasterVariantId;
  var syncVariantToPdp = H.syncVariantToPdp;
  var timeDdPortalEl = H.timeDdPortalEl;
  var cleanupOrphanTimeDdPanels = H.cleanupOrphanTimeDdPanels;
  var ensureTimeDdPortal = H.ensureTimeDdPortal;
  var getCalTimeDdParts = H.getCalTimeDdParts;
  var positionTimeDdPanel = H.positionTimeDdPanel;
  var resetTimeDdPanelStyle = H.resetTimeDdPanelStyle;
  var bindTimeDdReposition = H.bindTimeDdReposition;
  var wbwEmitVenueReset = H.wbwEmitVenueReset;
  var bindWizardSearchLayout = H.bindWizardSearchLayout;
  var venueHasBookableEvents = H.venueHasBookableEvents;
  var venueHasVisibleEvents = H.venueHasVisibleEvents;
  var venueIsWaitlistOnly = H.venueIsWaitlistOnly;
  var variantCardLayout = H.variantCardLayout;
  var wbwAddonDisplayTitle = H.wbwAddonDisplayTitle;
  var isMobileViewport = H.isMobileViewport;
  var isDesktopViewport = H.isDesktopViewport;
  var variantGridColsCap = H.variantGridColsCap;
  var pickStackedGridColumns = H.pickStackedGridColumns;
  var variantGridGapPx = H.variantGridGapPx;
  var stackedThumbPx = H.stackedThumbPx;
  var pickVariantGridColumns = H.pickVariantGridColumns;
  var easeOutCubic = H.easeOutCubic;
  var carouselSlideScrollLeft = H.carouselSlideScrollLeft;
  var pinCarouselToRow = H.pinCarouselToRow;
  var animateCarouselScrollLeft = H.animateCarouselScrollLeft;
  var syncVariantCarouselNav = H.syncVariantCarouselNav;
  var applyVariantCarouselLayout = H.applyVariantCarouselLayout;
  var clearVariantCarouselLayout = H.clearVariantCarouselLayout;
  var applyVariantGridLayout = H.applyVariantGridLayout;
  var bindVariantGridResize = H.bindVariantGridResize;
  var variantQtyControlHtml = H.variantQtyControlHtml;
  var splitFullName = H.splitFullName;

  function initRoot(wizardRoot) {
    if (!window.WorkshopBookingWizardFlow || typeof window.WorkshopBookingWizardFlow.attach !== "function") {
      console.error('[WBW] workshop-booking-wizard-flow.js missing');
      return;
    }
    window.WorkshopBookingWizardFlow.attach({
      wizardRoot: wizardRoot,
      Flow: Flow,
      LiveApi: LiveApi,
      WizardLive: WizardLive,
      WBWUtils: WBWUtils,
      MONTHS: MONTHS,
      DOW_PICKER: DOW_PICKER,
      DOW_MED: DOW_MED,
      DOW_SHORT: DOW_SHORT,
      VARIANT_ROW_MIN_PX: VARIANT_ROW_MIN_PX,
      VARIANT_ROW_MIN_H_PX: VARIANT_ROW_MIN_H_PX,
      VARIANT_GRID_GAP_PX: VARIANT_GRID_GAP_PX,
      getLiveApi: getLiveApi,
      getWizardLive: getWizardLive,
      parseData: parseData,
      WB_WORKSHOP_TYPES: WB_WORKSHOP_TYPES,
      workshopTypeFromText: workshopTypeFromText,
      fetchWorkshopTypeFromProduct: fetchWorkshopTypeFromProduct,
      resolveWaitlistWorkshopType: resolveWaitlistWorkshopType,
      parseSiblingPromoData: parseSiblingPromoData,
      siblingPromoScope: siblingPromoScope,
      attachSiblingPromoHost: attachSiblingPromoHost,
      ensureSiblingPromoDom: ensureSiblingPromoDom,
      siblingPromoHosts: siblingPromoHosts,
      WB_HANDLE_ALIAS_GROUPS: WB_HANDLE_ALIAS_GROUPS,
      handlesMatchForPromo: handlesMatchForPromo,
      canonicalPromoHandle: canonicalPromoHandle,
      normalizeTimeLabel: normalizeTimeLabel,
      parseTimeLabelParts: parseTimeLabelParts,
      formatHourMinuteMeridiem: formatHourMinuteMeridiem,
      timePartsToMinutes: timePartsToMinutes,
      formatSessionTimeRange: formatSessionTimeRange,
      buildPromoVenueContext: buildPromoVenueContext,
      venueRowMatchesContextScore: venueRowMatchesContextScore,
      resolvePromoDeepLinkFromIndex: resolvePromoDeepLinkFromIndex,
      WB_SIBLING_HANDLE_FALLBACKS: WB_SIBLING_HANDLE_FALLBACKS,
      WB_SIBLING_LABELS: WB_SIBLING_LABELS,
      parseVenueWaitlistCatalog: parseVenueWaitlistCatalog,
      findCatalogVenueByToken: findCatalogVenueByToken,
      parseVenueWorkshopIndex: parseVenueWorkshopIndex,
      findIndexRowByEventId: findIndexRowByEventId,
      promoEventIdMatchesVenueContext: promoEventIdMatchesVenueContext,
      resolveVenueAnchoredPromoEventId: resolveVenueAnchoredPromoEventId,
      resolveEventIdForProductAtVenue: resolveEventIdForProductAtVenue,
      slotListContainsEventId: slotListContainsEventId,
      resolveSiblingEventIdFromSessionAnchor: resolveSiblingEventIdFromSessionAnchor,
      venueRefAliasKeys: venueRefAliasKeys,
      venueNameLookupKey: venueNameLookupKey,
      buildVenueWorkshopMaps: buildVenueWorkshopMaps,
      normalizeVenueRefId: normalizeVenueRefId,
      ensureSiblingWorkshops: ensureSiblingWorkshops,
      collectAlsoAvailableHandles: collectAlsoAvailableHandles,
      escapeHtml: escapeHtml,
      extractNumericEventIdForUrl: extractNumericEventIdForUrl,
      extractNumericVariantIdForUrl: extractNumericVariantIdForUrl,
      extractNumericVenueRefForUrl: extractNumericVenueRefForUrl,
      extractEventIdFromUrl: extractEventIdFromUrl,
      extractPromoEventIdFromProduct: extractPromoEventIdFromProduct,
      refsOverlap: refsOverlap,
      venueNamesLooselyMatch: venueNamesLooselyMatch,
      venueMatchesIndexRow: venueMatchesIndexRow,
      readInitialVariantIdFromUrl: readInitialVariantIdFromUrl,
      getEventIdFromUrl: getEventIdFromUrl,
      getVenueTokenFromUrl: getVenueTokenFromUrl,
      getCityTokenFromUrl: getCityTokenFromUrl,
      getDateFromUrl: getDateFromUrl,
      cityUrlToken: cityUrlToken,
      urlHasWizardDeepLink: urlHasWizardDeepLink,
      venueCardIsWaitlistOnly: venueCardIsWaitlistOnly,
      getWbwStepFromUrl: getWbwStepFromUrl,
      clearWbwStepFromUrl: clearWbwStepFromUrl,
      isVenueHandleToken: isVenueHandleToken,
      venueUrlToken: venueUrlToken,
      venueHandleFromSlotRaw: venueHandleFromSlotRaw,
      venueMatchesUrlToken: venueMatchesUrlToken,
      updateWizardBookingUrl: updateWizardBookingUrl,
      formatMoney: formatMoney,
      slotBookable: slotBookable,
      slotStatus: slotStatus,
      slotDisplayStatus: slotDisplayStatus,
      slotHidden: slotHidden,
      slotSoldOut: slotSoldOut,
      slotVisible: slotVisible,
      formatSlotOptionText: formatSlotOptionText,
      slotDateKey: slotDateKey,
      padDatePart: padDatePart,
      toIsoDateKey: toIsoDateKey,
      timeLabelFromDateTime: timeLabelFromDateTime,
      normalizeEventToSlot: normalizeEventToSlot,
      eventsToSlots: eventsToSlots,
      buildDaysMap: buildDaysMap,
      wizardViewportWidth: wizardViewportWidth,
      calendarDowLabels: calendarDowLabels,
      calDateKey: calDateKey,
      formatCalDateBtn: formatCalDateBtn,
      formatBookingSubLabel: formatBookingSubLabel,
      isStoreVenue: isStoreVenue,
      formatPopupDateLabel: formatPopupDateLabel,
      vQtyKey: vQtyKey,
      normalizeOptionValue: normalizeOptionValue,
      styleValueFromVariant: styleValueFromVariant,
      getSectionRoot: getSectionRoot,
      isSessionOptionHandle: isSessionOptionHandle,
      parseVariantsJson: parseVariantsJson,
      ensureVariantMediaMeta: ensureVariantMediaMeta,
      findShopifyVariantByWizard: findShopifyVariantByWizard,
      findStyleFieldset: findStyleFieldset,
      getProductContainer: getProductContainer,
      goToImpulseVariantMedia: goToImpulseVariantMedia,
      parseZoomThumbMediaId: parseZoomThumbMediaId,
      parseZoomSlideMediaId: parseZoomSlideMediaId,
      goToZoomGalleryByMediaId: goToZoomGalleryByMediaId,
      findImpulseMediaSlide: findImpulseMediaSlide,
      resolveImpulseMediaZoomPosition: resolveImpulseMediaZoomPosition,
      raiseImpulseProductModal: raiseImpulseProductModal,
      openImpulseProductZoom: openImpulseProductZoom,
      closeImpulseProductZoom: closeImpulseProductZoom,
      openWizardVariantImageFallback: openWizardVariantImageFallback,
      syncImpulseStyleOption: syncImpulseStyleOption,
      syncImpulseOptionsByVariant: syncImpulseOptionsByVariant,
      syncImpulseMasterVariantId: syncImpulseMasterVariantId,
      syncVariantToPdp: syncVariantToPdp,
      timeDdPortalEl: timeDdPortalEl,
      cleanupOrphanTimeDdPanels: cleanupOrphanTimeDdPanels,
      ensureTimeDdPortal: ensureTimeDdPortal,
      getCalTimeDdParts: getCalTimeDdParts,
      positionTimeDdPanel: positionTimeDdPanel,
      resetTimeDdPanelStyle: resetTimeDdPanelStyle,
      bindTimeDdReposition: bindTimeDdReposition,
      wbwEmitVenueReset: wbwEmitVenueReset,
      bindWizardSearchLayout: bindWizardSearchLayout,
      venueHasBookableEvents: venueHasBookableEvents,
      venueHasVisibleEvents: venueHasVisibleEvents,
      venueIsWaitlistOnly: venueIsWaitlistOnly,
      variantCardLayout: variantCardLayout,
      wbwAddonDisplayTitle: wbwAddonDisplayTitle,
      isMobileViewport: isMobileViewport,
      isDesktopViewport: isDesktopViewport,
      variantGridColsCap: variantGridColsCap,
      pickStackedGridColumns: pickStackedGridColumns,
      variantGridGapPx: variantGridGapPx,
      stackedThumbPx: stackedThumbPx,
      pickVariantGridColumns: pickVariantGridColumns,
      easeOutCubic: easeOutCubic,
      carouselSlideScrollLeft: carouselSlideScrollLeft,
      pinCarouselToRow: pinCarouselToRow,
      animateCarouselScrollLeft: animateCarouselScrollLeft,
      syncVariantCarouselNav: syncVariantCarouselNav,
      applyVariantCarouselLayout: applyVariantCarouselLayout,
      clearVariantCarouselLayout: clearVariantCarouselLayout,
      applyVariantGridLayout: applyVariantGridLayout,
      bindVariantGridResize: bindVariantGridResize,
      variantQtyControlHtml: variantQtyControlHtml,
      splitFullName: splitFullName,
    });
  }


  function boot() {
    var roots = document.querySelectorAll('[data-workshop-booking-wizard]');
    roots.forEach(function (root) {
      try {
        initRoot(root);
      } catch (bootErr) {
        window.__wbwPromoDiag = {
          scriptLoaded: true,
          phase: 'initRoot-error',
          error: String(bootErr && bootErr.message ? bootErr.message : bootErr),
          wizardRoots: roots.length,
          hostCount: document.querySelectorAll('[data-workshop-sibling-promo]').length,
        };
      }
    });
    if (!window.__wbwPromoDiag || window.__wbwPromoDiag.phase === 'parsing') {
      window.__wbwPromoDiag = {
        scriptLoaded: true,
        phase: 'boot-fallback',
        show: false,
        branch: '',
        flow: '',
        hasVenue: false,
        hasSlot: false,
        hostCount: document.querySelectorAll('[data-workshop-sibling-promo]').length,
        hasWrap: !!document.querySelector('[data-wbw-sibling-promo-wrap]'),
        hasList: !!document.querySelector('[data-wbw-sibling-promo-list]'),
        slotAaLen: 0,
        venueEvents: 0,
        itemCount: 0,
        wizardRoots: roots.length,
        note: 'wizard sync did not run',
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
